import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.link/ut4sjx" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105 group" data-id="element-225">
      <MessageCircle className="w-5 h-5 group-hover:rotate-12 transition-transform" data-id="element-226" />
      <span className="hidden sm:inline" data-id="element-227">Soporte WhatsApp</span>
    </a>;
}